import { gql } from 'apollo-boost';

export const addDialogMutation = gql`
    mutation AddDialogMutation($input: GdAddDialogRequestInput!) {
        addDialog(input: $input) {
            dialog {
                clientId
                id
                isActive
                name
                skillId
            }
            validationResult {
                errors {
                    code
                    params
                    path
                }
                warnings {
                    code
                    params
                    path
                }
            }
        }
    }
`;
